import axios from "axios";
import baseUrl from "./baseURL";

export default axios.create({
    baseURL: baseUrl(),
    withCredentials: true,
    headers: {
        "Content-type": "application/json"
    }
});

